/**
 * @public
 * Checks if field value is a valid US zipcode.
 *
 * @param  {Element} field: field element holding the zip code.
 * @param  {Object} ruleConfig: Configuration to the rule.
 * @return {Promise} indicates if the zipcode is valid
 */
export default function zipcode({field, value, message}) {
  if (/(^\d{5}$)/.test(value)) {
    return {
      field,
      isValid: true,
    };
  }

  return {
    field,
    isValid: false,
    message,
  };
}
